import Cookies from 'js-cookie'

export const getCookie = name => {
  return Cookies.get(name)
}

export const setCookie = (name, token, expires) => {
  const exp = new Date(expires)
  return Cookies.set(name, token, { expires: exp })
}

export const removeCookie = name => {
  return Cookies.remove(name)
}
